export const searchBy = {
  keyword: 'searchKeyword'
};
